module.exports = __webpack_public_path__ + "img/3.3500c7f3.png";